module.exports = __webpack_public_path__ + "r-v3/img/gooroomee_study_download_image2.9a8129c0.png";